import React, { Fragment, useEffect } from "react";

import NewNavbar from "../../new-components/NewNavbar";
import NewOverrides from "../../new-components/NewOverrides";
import NewDesignSystem from "../../new-components/NewDesignSystem";
import NewPageHeader from "../../new-components/NewPageHeader";
import NewPageHero from "../../new-components/NewPageHero";
import MissionContent from "../../new-components/MissionContent";
import NewBackButton from "../../new-components/NewBackButton";
import NewFooter from "../../new-components/NewFooter";
import NewMadeWith from "../../new-components/NewMadeWith";
import NewScrollTop from "../../new-components/NewScrollTop";

const MisiunePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Fragment>
      <NewNavbar />
      <NewOverrides />
      <NewDesignSystem />

      <NewPageHeader />
      <NewPageHero
        title="Misiunea mea"
        subtitle="sǎ inspir, sǎ educ, sǎ îndrum"
      />

      <MissionContent />

      <NewBackButton />
      <NewFooter />
      <NewMadeWith />
      <NewScrollTop />
    </Fragment>
  );
};

export default MisiunePage;
